import { createSelector } from '@ngrx/store';
import { getSharedFeatureState } from '../shared.state';

export class ProviderSelectors {
  private static readonly getProviderState = createSelector(getSharedFeatureState, (state) => state.providerState);
  
  static readonly getProviders = createSelector(ProviderSelectors.getProviderState, (state) => state?.providers);
  static readonly getError = createSelector(ProviderSelectors.getProviderState, (state) => state?.error);
}
